import { render, staticRenderFns } from "./MerchantInfoItem.vue?vue&type=template&id=58d04890&scoped=true"
import script from "./MerchantInfoItem.vue?vue&type=script&lang=js"
export * from "./MerchantInfoItem.vue?vue&type=script&lang=js"
import style0 from "./MerchantInfoItem.vue?vue&type=style&index=0&id=58d04890&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d04890",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58d04890')) {
      api.createRecord('58d04890', component.options)
    } else {
      api.reload('58d04890', component.options)
    }
    module.hot.accept("./MerchantInfoItem.vue?vue&type=template&id=58d04890&scoped=true", function () {
      api.rerender('58d04890', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/system/components/MerchantInfoItem.vue"
export default component.exports